var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "detaillist" }, [
    _c("div", { staticClass: "header" }, [
      _c("div", { staticClass: "title" }, [
        _vm._v(
          "\n            接收对象:" + _vm._s(_vm.receiverType) + "\n        "
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "settingbtn" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-outline btn-primary",
            attrs: { type: "button" },
            on: { click: _vm.downloadList }
          },
          [_vm._v("导出名单")]
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "section" },
      [
        _c("div", { staticClass: "detail_list_item head" }, [
          _c("span", { staticClass: "num" }, [_vm._v("序号")]),
          _vm._v(" "),
          _c("span", { staticClass: "org_name" }, [_vm._v("名称")]),
          _vm._v(" "),
          _c("span", { staticClass: "name" }, [_vm._v("姓名")]),
          _vm._v(" "),
          _c("span", { staticClass: "phone" }, [_vm._v("手机号")]),
          _vm._v(" "),
          _c("span", { staticClass: "region_name" }, [_vm._v("所属区域")]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "status",
              staticStyle: { cursor: "pointer" },
              on: {
                click: function($event) {
                  _vm.showPopover(!_vm.isShowPop)
                }
              }
            },
            [
              _vm._v("状态\n              "),
              _c("i", {
                staticClass: "el-icon-arrow-down",
                staticStyle: { "font-size": "'12px'" }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isShowPop,
                  expression: "isShowPop"
                }
              ],
              staticClass: "pop"
            },
            [
              _c(
                "div",
                { staticStyle: { "margin-left": "10px" } },
                [
                  _c(
                    "el-radio",
                    {
                      attrs: { label: "2" },
                      model: {
                        value: _vm.statusType,
                        callback: function($$v) {
                          _vm.statusType = $$v
                        },
                        expression: "statusType"
                      }
                    },
                    [_vm._v("全部")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { "margin-left": "10px" } },
                [
                  _c(
                    "el-radio",
                    {
                      attrs: { label: "0" },
                      model: {
                        value: _vm.statusType,
                        callback: function($$v) {
                          _vm.statusType = $$v
                        },
                        expression: "statusType"
                      }
                    },
                    [_vm._v("未读")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { "margin-left": "10px" } },
                [
                  _c(
                    "el-radio",
                    {
                      attrs: { label: "1" },
                      model: {
                        value: _vm.statusType,
                        callback: function($$v) {
                          _vm.statusType = $$v
                        },
                        expression: "statusType"
                      }
                    },
                    [_vm._v("已读")]
                  )
                ],
                1
              )
            ]
          )
        ]),
        _vm._v(" "),
        _vm._l(_vm.data, function(item, index) {
          return _vm.showItem(item)
            ? _c("div", { key: index, staticClass: "detail_list_item" }, [
                _c("span", { staticClass: "num" }, [_vm._v(_vm._s(item.num))]),
                _vm._v(" "),
                _c("span", { staticClass: "org_name" }, [
                  _vm._v(_vm._s(item.orgName))
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "name" }, [
                  _vm._v(_vm._s(item.name))
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "phone" }, [
                  _vm._v(_vm._s(item.phone))
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "region_name" }, [
                  _vm._v(_vm._s(item.regionName))
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "status" }, [
                  _vm._v(_vm._s(item.status))
                ])
              ])
            : _vm._e()
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9de02574", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9de02574","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/notice/detailList.vue
// module id = null
// module chunks = 